import { EntityState, StoreConfig, Store } from '@datorama/akita';
import { Injectable } from '@angular/core';
import { AbstractUiEntityStore } from 'projects/app-misc/src/app/modules/data/abstract-ui-entity.store';
import { KanbanColumn } from './kanban-column';
import { Project } from 'projects/app-misc/src/app/modules/project-misc/data/project/project';
import { User } from 'projects/core/src/lib/login/data/user';
import { ProjectStatus } from 'projects/app-misc/src/app/modules/project-misc/data/project/statuses/project-status';

export class KanbanBoardFilters {
    columns: number[];
    managers: number[];
    customers: number[];
    paymentStatuses: number[];
}


export interface KanbanBoardState extends EntityState<KanbanColumn, number> {
    ui: {
        activeColumn: {
            id: number
        },
        filter: KanbanBoardFilters,
        columnsIdsToShow: number[]
        updateBoard: number
    };
    newProject: Project;

}
@Injectable({
    providedIn: 'root'
})
@StoreConfig({ name: 'kanbanBoard' })
export class KanbanBoardStore extends AbstractUiEntityStore<KanbanBoardState> {
    constructor() {
        super({
            ui: {
                activeColumn: null,
                filter: {
                    columns: undefined,
                    managers: undefined,
                    customers: undefined,
                    paymentStatuses: undefined
                },
                columnsIdsToShow: [],
                updateBoard: 0
            }
        })
    }

    updateActiveColumnId(activeColumnId: number) {
        this.updateUi({
            activeColumn: {
                id: activeColumnId
            }
        })
    }

    newProject(newProject: Project) {
        this.update({
            ...this._value(),
            newProject
        })
    }

    updateColumnsFilter(columns: number[]) {
        this.updateUi({
            filter: {
                ...this._value().ui.filter,
                columns
            },
        })
    }

    updateManagersFilter(managers: number[]) {
        this.updateUi({
            filter: {
                ...this._value().ui.filter,
                managers
            }
        })
    }

    updateCustomersFilter(customers: number[]) {
        this.updateUi({
            filter: {
                ...this._value().ui.filter,
                customers
            }
        })
    }

    updatePaymentStatusesFilter(paymentStatuses: number[]) {
        this.updateUi({
            filter: {
                ...this._value().ui.filter,
                paymentStatuses
            }
        })
    }

    updateColsToShow(columnsId: number[]) {
        this.updateUi({
            ...this._value(),
            columnsIdsToShow: columnsId
        })
    }

    insertColumn(column: KanbanColumn) {
        this.add(column);
        const cols = this.getValue().entities;
        const ids = this.getValue().ids;
        let i = ids.length - 1;


        while (i >= 0) {
            const id = ids[i];
            if (cols[id].pos < column.pos) {
                break;
            }
            i--;
        }
        this.move(ids.length - 1, i + 1)
    }

    updateKanbanBoard() {
        this.updateUi({
            ...this._value(),
            updateBoard: this._value().ui.updateBoard + 1
        })
    }

    deleteColumn(column: KanbanColumn) {
        this.remove(column.id)
    }

}